import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=6b710d86&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=6b710d86&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b710d86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b710d86')) {
      api.createRecord('6b710d86', component.options)
    } else {
      api.reload('6b710d86', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=6b710d86&scoped=true&", function () {
      api.rerender('6b710d86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2csjD6PcDjcbq/JS/comp/Paginate.vue"
export default component.exports